import axios from 'axios';

const API_BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost:5000/api';

const api = axios.create({
  baseURL: API_BASE_URL,
  timeout: 30000,
  headers: {
    'Content-Type': 'application/json',
  },
});

api.interceptors.response.use(
  (response) => response,
  (error) => {
    console.error('API Error:', error);
    return Promise.reject(error);
  }
);

export const apiService = {
  sendMessage: async (message, language = 'es', conversationHistory = []) => {
    try {
      const response = await api.post('/chat', {
        message,
        language,
        conversationHistory
      });
      return response.data;
    } catch (error) {
      console.error('Error sending message:', error);
      
      try {
        const fallbackResponse = await api.post('/chat/fallback', {
          language
        });
        return fallbackResponse.data;
      } catch (fallbackError) {
        return {
          success: true,
          response: language === 'es' 
            ? "Disculpa, estoy teniendo problemas técnicos. Por favor, intenta de nuevo en unos momentos."
            : "Sorry, I'm having technical issues. Please try again in a few moments.",
          fallback: true
        };
      }
    }
  },

  checkHealth: async () => {
    try {
      const response = await api.get('/health');
      return response.data;
    } catch (error) {
      throw new Error('Server is not responding');
    }
  },

  setBaseURL: (url) => {
    api.defaults.baseURL = url;
  }
};

export default apiService;